
import { ArticleData } from "./types";

export const evolutionCandidateGeneration: ArticleData = {
  id: 12,
  slug: "evolution-candidate-generation",
  title: "Evolution of Candidate generation algorithms",
  author: 'Bharathi Priyaa',
  description: 'An overview of candidate generation algorithms from collaborative filtering to modern two-tower networks.',
  publishDate: 'April 17, 2025',
  lastUpdated: "May 8, 2025",
  category: "ML System Design",
  readTime: "12 min read",
  readCount: 20,
  likeCount: 2,
  isPremium: true,
  contentType: "markdown",
  // Use the correct path structure
  contentPath: "docs/evolution.md",
  tags: ["machine learning", "candidate generation", "system design"],
  isPreviewEnabled: true // Enable preview mode for this article
};
